export default {
  addUpload({ commit }, payload) {
    commit('UPLOAD_ADD', payload);
  },
  updateUpload({ commit }, payload) {
    commit('UPLOAD_UPDATE', payload);
  },
  removeUpload({ commit }, payload) {
    commit('UPLOAD_REMOVE', payload);
  },
  clearUpload({ commit }) {
    commit('UPLOAD_CLEAR');
  },
  setUploadCancelToken({ commit }, payload) {
    commit('UPLOAD_CANCEL', payload);
  },
}
